import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    DialogActions,
    Button,
    useTheme,
    Box,
    Typography
} from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';

const EmailSelectionDialog = ({ open, onClose, emails, onSelect }) => {
    const theme = useTheme();

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    '& .MuiDialogTitle-root': {
                        backgroundColor: theme.palette.primary.main,
                        color: 'white',
                        py: 2
                    }
                }
            }}
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailIcon />
                    <Typography variant="h6" component="span">
                        Select Email Address
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <DialogContentText sx={{ mb: 3, color: 'text.primary' }}>
                    Multiple email addresses were found for your account. Please select which email address you'd like to receive the sign-in link on:
                </DialogContentText>
                <List sx={{ 
                    mt: 1,
                    '& .MuiListItem-root:not(:last-child)': {
                        mb: 1
                    }
                }}>
                    {emails.map((email, index) => (
                        <ListItem key={index} disablePadding>
                            <ListItemButton 
                                onClick={() => onSelect(index)}
                                sx={{
                                    border: '1px solid',
                                    borderColor: theme.palette.success.light,
                                    borderRadius: 1,
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: theme.palette.success.light + '1A',
                                        borderColor: theme.palette.success.main,
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <EmailIcon sx={{ mr: 2, color: theme.palette.success.main }} />
                                    <ListItemText 
                                        primary={email}
                                        primaryTypographyProps={{
                                            sx: { 
                                                fontWeight: 500,
                                                color: 'text.primary'
                                            }
                                        }}
                                    />
                                </Box>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    color="primary"
                    sx={{
                        borderRadius: 1,
                        textTransform: 'none',
                        px: 3
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmailSelectionDialog; 